//@@ Store
import { createAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { DataStore } from 'aws-amplify'
import { NotificationModel } from '@src/models'

//@@ Constants
import { LOADING_STATE } from 'constants/api'

const SLICE_NAME = 'appNotifications'

export const removeNotification = createAsyncThunk(`${SLICE_NAME}/remove-notification`, async ({ id }) => {
  const removedNotification = await DataStore.query(NotificationModel, id)
  await DataStore.delete(removedNotification)
})

export const addNotifications = createAction('add-notification-observe')

export const notificationsReducer = createSlice({
  name: SLICE_NAME,
  initialState: {
    data: [],
    loadingState: LOADING_STATE.IDLE
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(removeNotification.pending, (s) => {
      s.loadingState = LOADING_STATE.PENDING
    })
    builder.addCase(removeNotification.fulfilled, (s) => {
      s.loadingState = LOADING_STATE.FINISHED
    })
    builder.addCase(addNotifications, (s, a) => {
      s.data = a.payload.data
    })
  }
})

export default notificationsReducer.reducer
